export default __webpack_public_path__ + "1fa20affbf3e38bde179102fffea3500.png";